import React from "react";
import { MenuAdV2Card } from "./MenuAdV2";

// Standalone, chrome-free version of the Facebook ad at full 1080×1350.
// Open this URL in a new tab → right-click the image card and "Save image as…"
// or take a full-page screenshot for a sharp 1080×1350 export.
export default function MenuAdV2Photo() {
  return (
    <div
      data-testid="menu-ad-v2-photo-page"
      className="min-h-screen w-full bg-black flex items-start justify-center"
      style={{ padding: 0 }}
    >
      <MenuAdV2Card scale={2} />
    </div>
  );
}
